document.addEventListener('DOMContentLoaded', () => {
	console.log('NAV - New Navigation Design', 'v1.0', 'Test Bucketed');

	(() => {
		const globalVariables = {
			clientName: 'clientName',
			project: 'projectName',
			testName: 'NAV - New Navigation Design',
			pageInitials: 'oz36',
			testVariation: 1,
			testVersion: 1.0,
			data: {
				bestSellers: [
					{
						productName: `Eco Bliss`,
						productUrl: ` /products/eco-bliss-hybrid-latex-mattress`,
						productInfo: `Eco Friendly`,
						productSecondaryInfo: `No Springs`,
					},
					{
						productName: `Luxury Bliss`,
						productUrl: ` /products/12-luxury-bliss-natural-latex-mattress-with-encased-coils`,
						productInfo: `Hybrid Luxury`,
						productSecondaryInfo: `With Springs`,
					},
					{
						productName: `Botanical Bliss `,
						productUrl: `/products/the-botanical-bliss-organic-latex-mattress`,
						productInfo: `Most Popular`,
						productSecondaryInfo: `No Springs`,
					},
					{
						productName: `Organic Bliss`,
						productUrl: ` /products/organic-mattress`,
						productInfo: `Luxury Pillowtop`,
						productSecondaryInfo: `No Springs`,
					},
					{
						productName: `Signature Bliss`,
						productUrl: ` /products/pillowtop-mattress`,
						productInfo: `Ultra-Plush`,
						productSecondaryInfo: `With Springs`,
					},
					{
						productName: `Royal Bliss`,
						productUrl: ` /products/luxury-mattress`,
						productInfo: `European Luxury`,
						productSecondaryInfo: `With Springs`,
					},
					{
						productName: `Heavenly Plush Luxury Hybrid Mattress`,
						productUrl: ` /products/heavenly-plush-luxury-hybrid-mattress`,
						productInfo: ``,
						productSecondaryInfo: ``,
					},
				],

				otherMatts: [
					{
						productName: `Organic Kids Mattress`,
						productUrl: ` /products/healthy-child-organic-latex-mattress`,
						productInfo: ``,
					},
					{
						productName: `Hybrid Kids Mattress`,
						productUrl: ` /products/healthy-child-hybrid-mattress`,
						productInfo: ``,
					},
					{
						productName: `Cooling Gel Kids Mattress`,
						productUrl: ` /products/12-cool-bliss-luxury-memory-foam-mattress`,
						productInfo: ``,
					},
					{
						productName: `Sofa Bed Mattress`,
						productUrl: ` /products/memory-foam-sofa-bed-mattress`,
						productInfo: `Memory Foam`,
					},
					{
						productName: `Sofa Bed Mattress`,
						productUrl: ` /products/cool-bliss-gel-sofa-mattress`,
						productInfo: `Cooling Gel`,
					},
					{
						productName: `Sofa Bed Mattress`,
						productUrl: ` /products/slice-of-heaven-eco-green-sofa-mattress`,
						productInfo: `Organic Latex`,
					},
					{
						productName: `RV Mattress - 6" Classic`,
						productUrl: ` /products/mobileplush-6-original-rv-mattress`,
						productInfo: ``,
					},
					{
						productName: `RV Mattress - 8" Organic Latex`,
						productUrl: ` /products/mobileplush-eco-green-8-rv-mattress`,
						productInfo: ``,
					},
				],

				comparePage: `https://www.plushbeds.com/pages/compare-mattresses`,

				bbImg: `https://cdn.shopify.com/s/files/1/0061/7195/1202/files/Image_9_2e356ce2-d2ad-42e3-bab9-1865a9b3cabf.png?v=1764079026`,

				plusImg: `https://cdn.shopify.com/s/files/1/0061/7195/1202/files/Image_11_55fcb33b-c619-45ac-b05b-5b22f292a835.png?v=1764304639`,

				minusImg: `https://cdn.shopify.com/s/files/1/0061/7195/1202/files/Image_10_0e72cabe-0044-4f87-97ec-bc995aa46f61.png?v=1764304647`,

				bbUrl: `https://www.plushbeds.com/products/the-botanical-bliss-organic-latex-mattress`,
			},
		};

		function waitForElement(
			predicate,
			callback,
			timer = 20000,
			frequency = 150
		) {
			try {
				if (timer <= 0) {
					throw new Error(
						`Timeout reached while waiting for condition: ${predicate.toString()}`
					);
				} else if (predicate && predicate()) {
					callback();
				} else {
					setTimeout(() => {
						waitForElement(
							predicate,
							callback,
							timer - frequency,
							frequency
						);
					}, frequency);
				}
			} catch (error) {
				console.warn(error);
				return;
			}
		}

		function init() {
			const body = document.querySelector('body');
			body.classList.add(globalVariables.pageInitials);

			addNewMattNav();
			clickDetector();
		}

		function addNewMattNav() {
			//

			let originalMattNav = document.querySelector(
				'.dropdown.mega-menu:nth-child(2) .container.style_3:first-of-type'
			);

			const bestSellerList = globalVariables.data.bestSellers
				.map(
					(item) => `
		      <a href="${item.productUrl}" class="oz36__new-nav__coll__list-item ${item.productName
					.toLowerCase()
					.replace(/\s+/g, '-')}">
		        ${item.productName}
	            
	            ${item.productInfo ? `<span>${item.productInfo}</span>` : ''}
	            ${item.productSecondaryInfo ? `<span class="oz36__new-nav__coll__list-item__secondary-tag">${item.productSecondaryInfo}</span>` : ''}
		        
		      </a>
		    `
				)
				.join('');

			const otherMattList = globalVariables.data.otherMatts
				.map(
					(item) => `
				    <a href="${item.productUrl}" class="oz36__new-nav__coll__list-item ${item.productName
						.toLowerCase()
						.replace(/\s+/g, '-')}">
			    		${item.productName}
	            		${item.productInfo ? `<span>${item.productInfo}</span>` : ''}
		    		</a>
				  `
				)
				.join('');

			let injectedNewNav = `
		<div class="oz36__new-nav__wrapper">
			<div class="oz36__new-nav__wrap">
				<div class="oz36__new-nav__coll order-1 tab-order-1">
					<div class="oz36__new-nav__coll__img">
						<img src="${globalVariables.data.bbImg}">
					</div>
					<div class="oz36__new-nav__coll__header">
						<a href="https://www.plushbeds.com/products/the-botanical-bliss-organic-latex-mattress">Botanical Bliss Mattress <span>(Rated #1)</span></a>
					</div>
					<div class="oz36__new-nav__coll__sub-header">
						<p>Our #1 organic luxury mattress crafted with <br>premium natural materials.</p>
					</div>
					<div class="oz36__new-nav__coll__cta">
						<a href="https://www.plushbeds.com/products/the-botanical-bliss-organic-latex-mattress">SHOP NOW</a>
					</div>
				</div>
				
				<div class="oz36__new-nav__coll order-1">
					<div class="oz36__new-nav__coll__list-header">
						<p>BEST SELLERS</p>
						
						<img class="plusIcon" src="${globalVariables.data.plusImg}">
						<img class="minusIcon" src="${globalVariables.data.minusImg}">
						
					</div>
					<div class="oz36__new-nav__coll__list-item-wrap">
						${bestSellerList}
					</div>
				</div>
				
				<div class="oz36__new-nav__coll order-3">
					<div class="oz36__new-nav__coll__list-header">
						<p>KIDS & OTHER MATTRESSES</p>
						
						<img class="plusIcon" src="${globalVariables.data.plusImg}">
						<img class="minusIcon" src="${globalVariables.data.minusImg}">
					</div>
					<div class="oz36__new-nav__coll__list-item-wrap">
						${otherMattList}
					</div>
				</div>
				
				<div class="oz36__new-nav__coll order-2 tab-order-1">
					<div class="oz36__new-nav__coll__cta order-2">
						<div class="oz36__new-nav__coll__cta-header">
							<p>Not Sure Which One?</p>
						</div>
						<div class="oz36__new-nav__coll__cta-subheader">
							<p>Compare all our mattresses side-by-side</p>
						</div>
						<div class="oz36__new-nav__coll__cta-main">
							<a href="https://www.plushbeds.com/pages/compare-mattresses">COMPARE OUR MATTRESSES</a>
						</div>
					</div>
					<div class="oz36__new-nav__coll__cta pt-3">
						<a href="#quiz-kit-key-uBjgb8J5H" class="">Find Your Perfect Mattress </a>
					</div>
				</div>
			</div>
		</div>
		
		`;

			originalMattNav.insertAdjacentHTML('afterend', injectedNewNav);
		}

		function clickDetector() {
			document.body.addEventListener('click', (e) => {
				if (e.target.closest('.oz36__new-nav__coll__list-header')) {
					e.target
						.closest('.oz36__new-nav__coll__list-header')
						.classList.toggle('__show-list');
				}
			});
		}

		function demo() {
			//
		}

		function hasTargetElement() {
			return (
				!!document.querySelector(
					`body:not(.${globalVariables.pageInitials})`
				) &&
				document.querySelector(
					`.dropdown.mega-menu:nth-child(2) .container.style_3:first-of-type`
				)
			);
		}

		// waitForElement(hasTargetElement, init);

		const triggerShopliftTest = async () => {
			try {
			/*	if (window.shoplift) {
					let v2IsBucketed = await window.shoplift.isHypothesisActive(
						'019b9380-2689-744a-b168-057eebd5d1c5'
					);

					console.log(
						'Shoplift test bucket v2 result:',
						v2IsBucketed
					);

					if (v2IsBucketed) {
						console.log('User is bucketed into Variant 2');*/
						// sessionStorage.setItem('oz36Nav', 'true');
						waitForElement(hasTargetElement, init);
						
				/*	} else {
						console.log('User is in control group');
					}
				} else {
					console.warn('Shoplift API not available');
				}*/
			} catch (error) {
				console.error('Error triggering Shoplift test:', error);
			}
		};

		// if (!sessionStorage.getItem('oz36Nav')) {
			triggerShopliftTest();
		// } else {
		// 	console.log('oz36 ---');
		// }
	})();
});
